var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoriesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EEF0F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27085_95110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20768 12.6786L13.0139 6.53906L16.8056 12.6786H9.20768ZM16.5851 19.4307C15.7953 19.4307 15.1218 19.1525 14.5645 18.5961C14.0072 18.0397 13.7285 17.362 13.7285 16.563C13.7285 15.772 14.0066 15.0946 14.5628 14.5307C15.1189 13.9668 15.7933 13.6849 16.586 13.6849C17.3867 13.6849 18.0635 13.9663 18.6161 14.529C19.1688 15.0918 19.4452 15.7725 19.4452 16.5711C19.4452 17.3698 19.168 18.046 18.6136 18.5999C18.0592 19.1538 17.383 19.4307 16.5851 19.4307ZM6.94727 19.0661V13.962H12.0368V19.0661H6.94727ZM16.5914 18.0891C17.0259 18.0891 17.3865 17.9438 17.6733 17.6533C17.9601 17.3628 18.1035 17.0006 18.1035 16.5669C18.1035 16.133 17.9597 15.7679 17.6721 15.4714C17.3845 15.1748 17.0234 15.0266 16.5889 15.0266C16.1544 15.0266 15.7902 15.1751 15.4964 15.4721C15.2025 15.7691 15.0556 16.1358 15.0556 16.572C15.0556 17.0041 15.2029 17.365 15.4976 17.6546C15.7923 17.9443 16.1569 18.0891 16.5914 18.0891ZM8.28893 17.7245H10.7098V15.3036H8.28893V17.7245ZM11.5993 11.337H14.3993L13.0139 9.06198L11.5993 11.337Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27085_95110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesIcon);
export default __webpack_public_path__ + "static/media/CategoriesIcon.ea6d2c4cbb90ccfc93d261fbf76dd2bb.svg";
export { ForwardRef as ReactComponent };